import React from "react";
import { IconClose, IconSearch } from "../Iconfont/Iconfont";
import { useTranslation } from "react-i18next";
import { isEmpty } from "lodash-es";

type KeywordInputProps = {
    value: string;
    onChange: (value: string) => void;
};

const KeywordInput: React.FC<KeywordInputProps> = ({ value, onChange }) => {
    const { t } = useTranslation();
    return (
        <div className="flex-auto h-[40px] bg-bg_bottom rounded-[8px] flex items-center px-[10px]">
            <IconSearch className="flex-none text-[24px] mr-2 text-text_3" />
            <input
                className="flex-auto w-0 text-body1 text-text_1 bg-transparent placeholder:text-text_3"
                placeholder={t("select_token_input_placeholder")}
                value={value}
                type="text"
                inputMode="text"
                autoComplete="off"
                spellCheck="false"
                onChange={(event) => {
                    const keyword = event.target.value;
                    onChange(keyword);
                }}
            />
            {!isEmpty(value) && (
                <IconClose
                    className="flex-none text-text_3 text-[16px] ml-1 cursor-pointer"
                    onClick={() => onChange("")}
                />
            )}
        </div>
    );
};

export default KeywordInput;
